<template>
  <div class="box">
    <h3>{{ survey.title }}</h3>
    <p v-html="survey.description"></p>
    <button class="button is-success" @click="showSurvey" v-if="!switches.showSurvey">Spustit Anketu</button>
    <template v-if="switches.showSurvey">
      <div class="field" v-for="(question, questionKey) in survey.questions" :key="questionKey">
        <label class="label">{{ question.question }}</label>
        <template v-if="question.type === 'choice'">
          <div class="control" v-for="(answer, answerKey) in question.choices" :key="answerKey">
            <input type="radio" @input="saveAnswers" v-model="answers[questionKey]" :value="answerKey">&nbsp;
            <span>
              {{ answer }}
            </span>
          </div>
        </template>
        <template v-if="question.type === 'multiple_choice'">
          <div class="control" v-for="(answer, answerKey) in question.choices" :key="answerKey">
            <input type="checkbox" @input="saveAnswers" v-model="answers[questionKey + '_' + answerKey]" :value="true">&nbsp;
            <span>
              {{ answer }}
            </span>
          </div>
        </template>
        <template v-if="question.type === 'rating'">
          <div class="control">
            <StarRating :max-rating="10" v-model="answers[questionKey]" @rating-selected="saveAnswers"></StarRating>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * Copyright (c) 2019. Filip Conka <filip@conka.pro>
 */
import { mapGetters } from 'vuex'
import StarRating from 'vue-star-rating'

export default {
  name: 'Survey',
  components: { StarRating },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      answers: {},
      switches: {
        showSurvey: false
      }
    }
  },
  computed: {
    ...mapGetters('surveys', {
      surveyStorage: 'getSurvey'
    }),
    survey () {
      return this.surveyStorage(this.id)
    }
  },
  methods: {
    showSurvey () {
      this.switches.showSurvey = true
    },
    saveAnswers () {
      this.$nextTick(() => this.$store.dispatch('surveys/updateAnsweredSurvey', { id: this.survey.id, answers: this.answers }))
    }
  }
}
</script>

<style scoped>

</style>
